const actionTypeIdentifier = '378EC888-D48A-4EC0-AA52-A320D74E284E'; //action identifier should be unique

export const updateRequestDetailModel = `UPDATE-REQUEST-DETAIL-MODEL-${actionTypeIdentifier}`;
export const updateRequestDetailIsError = `UPDATE-REQUEST-DETAIL-IS-ERROR-${actionTypeIdentifier}`;
export const updateSelectedRequest = `UPDATE-SELECTED-REQUEST-${actionTypeIdentifier}`;
export const setExhibitType = `SET-REQUEST-DETAIL-EXHIBIT-TYPE-${actionTypeIdentifier}`;
export const updateOrderRequest = `UPDATE-ORDER-REQUEST-${actionTypeIdentifier}`;
//progress  
export const updateRequestProgressData = `UPDATE-REQUEST-DETAIL-PROGRESS-DATA-${actionTypeIdentifier}`;
export const setPageSize = `SET-REQUEST-DETAIL-PROGRESS-PAGE-SIZE-${actionTypeIdentifier}`;
export const setReadMoreLoading = `SET-REQUEST-DETAIL-PROGRESS-READ-MORE-LOADING-${actionTypeIdentifier}`;
export const setErrorLoading = `SET-REQUEST-DETAIL-PROGRESS-ERROR-LOADING-${actionTypeIdentifier}`;
//comment
export const setErrorComments = `SET-REQUEST-DETAIL-COMMENT-ERROR-${actionTypeIdentifier}`;
export const updateCommentData = `UPDATE-REQUEST-DETAIL-COMMENT-MODEL-${actionTypeIdentifier}`;
export const setCommentPageSize = `SET-REQUEST-DETAIL-COMMENT-PAGE-SIZE-${actionTypeIdentifier}`;
export const setCommentData = `SET-REQUEST-DETAIL-COMMENT-DATA-${actionTypeIdentifier}`;
export const resetCommentData = `RESET-COMMENT-DATA-${actionTypeIdentifier}`;
//approve & reject
export const setApproverData = `SET-REQUEST-APPROVER-DATA-${actionTypeIdentifier}`;
export const updateOrderStatus = `UPDATE-REQUEST-ORDER-STATUS-${actionTypeIdentifier}`;
export const setRejectionComment = `SET-REJECTION-COMMENT-${actionTypeIdentifier}`;
export const showHideRejectComment = `SHOW-HIDE-REJECT-COMMENT-${actionTypeIdentifier}`;
export const showDecisionButton = `SHOW-DECISION-BUTTON-${actionTypeIdentifier}`;

export const setBusinessHoursNotice = `SET-BUSINESS-HOURS-NOTICE-${actionTypeIdentifier}`;






